<template>
  <img
    :src="src"
    :alt="alt"
    :width="width"
    :height="height"
    class="brand-logo"
    :class="`brand-logo--${variant}`"
    draggable="false"
  />
</template>

<script>
import logo from '@/assets/brand/mania-plus.svg'
import logoNegative from '@/assets/brand/mania-plus-negativ.svg'
import logoMono from '@/assets/brand/mania-plus-mono.svg'
import symbol from '@/assets/brand/favicon.svg'

// Originálne SVG z manuálu MANIA — logo sa nekreslí textom ani neprefarbuje.
// `default` (Ruby kruhy, biele písmená) platí na bielej aj čiernej ploche, `negative` na Ruby ploche,
// `symbol` je značka „m+“ (zbalený panel, favicon).
const SOURCES = { default: logo, negative: logoNegative, mono: logoMono, symbol }
const RATIO = { default: 107.9 / 198.43, negative: 107.9 / 198.43, mono: 107.9 / 198.43, symbol: 1 }

export default {
  name: 'BrandLogo',
  props: {
    variant: { type: String, default: 'default', validator: (v) => v in SOURCES },
    width: { type: [Number, String], default: 120 },
    alt: { type: String, default: 'Optika MANIA' },
  },
  computed: {
    src() {
      return SOURCES[this.variant]
    },
    height() {
      return Math.round(Number(this.width) * RATIO[this.variant])
    },
  },
}
</script>

<style scoped>
.brand-logo {
  display: block;
  max-width: 100%;
  height: auto;
  user-select: none;
}
</style>
